import React, { Component } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from "react-share";

class index extends Component {
  render() {
    return (
      <React.Fragment>
        <LinkedinShareButton
          url={this.props.url}
          title={this.props.title}
          description={this.props.quote}
        >
          <LinkedinIcon size={32} round={true} />
        </LinkedinShareButton>

        <FacebookShareButton url={this.props.url} quote={this.props.quote}>
          <FacebookIcon size={32} round={true} />
        </FacebookShareButton>

        <TwitterShareButton
          title={this.props.title}
          url={this.props.url}
          via={this.props.quote}
        >
          <TwitterIcon size={32} round={true} />
        </TwitterShareButton>
      </React.Fragment>
    );
  }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/ShareSnippets/index.js